import 'react-app-polyfill/stable';
import 'core-js/features/array/at';
import 'core-js/features/promise/any';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// PWA install helper (handles beforeinstallprompt)
import { showInstallPrompt } from './pwaInstall';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// ---- PWA: Service Worker registration ----
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(reg => console.log('Service Worker registered:', reg.scope))
      .catch(err => console.error('Service Worker registration failed:', err));
  });
}

// ---- PWA: Wire up the Install button (if present in index.html) ----
window.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('installBtn');
  if (btn) {
    btn.addEventListener('click', showInstallPrompt);
  }
});
